import { getV2Endpoint } from '@/utils/apiV2Endpoints';
import KmsHttpService from '@/servises/kmsHttpService';

export default {
    deleteCustomer: (id) => {
        const endpoint = getV2Endpoint({ 'group': 'customers', 'endpoint': 'manage' }, { id: id });
        return KmsHttpService.delete(endpoint, null);
    }
};
